export default {
    roleLoading: false,
    rolesListLoading: false,
    rolesList: [],
}